<template>
  <div class="flex min-h-screen flex-col">
    <div class="flex grow flex-col">
      <slot />
    </div>
  </div>
</template>
